import cloneDeep from 'lodash/cloneDeep';
// Marketing
export const marketingPriceIndex = 2;

// Pricing
export const analysisTableValueIndex = 1;
export const pricingCurrentPercentIndex = 1;
export const pricingCurrentValueIndex = 2;
export const pricingProformaPercentIndex = 5;
export const pricingProformaValueIndex = 6;

// Rent Roll
export const tenantIndex = 1;
export const annualRentIndex = 4;

// Reimbursement Types
export const reimbursementTypesNo = 15;
export const defaultReimbursementTypesNo = 7;
export const taxAssessmentsNo = 4;
export const adminFeeCellIndex = 2;
export const camCheckboxCellIndex = 3;
export const camCellIndex = 4;
export const mgmtCheckboxCellIndex = 5;
export const mgmtCellIndex = 6;
export const insuranceCheckboxCellIndex = 7;
export const insuranceCellIndex = 8;
export const taxesCheckboxCellIndex = 9;
export const taxesCellIndex = 10;
export const grossReimbCode = 7;
export const reimbCodeIndex = 2;
export const prorataShareIndex = 0;

// Reimbursable Expenses
export const reimbMgmtIndex = 5;
export const reimbInsuranceIndex = 6;
export const reimbTaxesIndex = 7;

// Expenses
export const camDefaultRowNo = 5;
export const expensesValueIndex = 2;
export const expensesPsfIndex = 3;

// ProForma Expenses
export const expensesPfPsfIndex = 6;

// const cloneDeep = require('lodash.clonedeep');

export function computeCamValue(checkbox, sum) {
    if (!checkbox)
        return 0;
    return sum ? parseFloat(sum) : 0;
}

export function computeMgmtValue(checkbox, mgmt, cam, adminFee) {
    
    if (!checkbox) {
        return 0;
    }
    
    if (!adminFee) {
        return mgmt;
    }
    
    const value = cam * (adminFee / 100);
    return value ? parseFloat(value) : 0;
}

export function computeInsuranceValue(checkbox, insurance) {
    if (!checkbox)
        return 0;
    return insurance ? parseFloat(insurance) : 0;
}

export function computeTaxesValue(checkbox, taxes) {
    if (!checkbox)
        return 0;
    return taxes ? parseFloat(taxes) : 0;
}

export function recomputeCam({tab, tabs, precomputedValues, index, newCheckbox = null}) {
    const cells = tabs[tab].tables['reimbursement-types'].rows[index].valueCells;
    const checkbox = newCheckbox === null ? cells[camCheckboxCellIndex].value : newCheckbox;
    const totalCamIndex = tab === 'current-reimbursement-tab' ? expensesPsfIndex : expensesPfPsfIndex;
    let sum = tabs['expenses-tab'].tables['expenses'].rows['total-cam'].valueCells[totalCamIndex].getComputedValue(tabs, precomputedValues).internalValue || 0;
    if (!isFinite(sum))
        sum = 0;
    return computeCamValue(checkbox, sum);
}

export function recomputeMgmt({tab, tabs, precomputedValues, index, newCheckbox = null, newAdminFee = null, newCam = null}) {
    
    const cells = tabs[tab].tables['reimbursement-types'].rows[index].valueCells;
    const checkbox = newCheckbox === null ? cells[mgmtCheckboxCellIndex].value : newCheckbox;
    const cam = newCam === null ? cells[camCellIndex].value : newCam;
    const adminFee = newAdminFee === null ? cells[adminFeeCellIndex].value : newAdminFee;
    
    const rowIdentifier = 'management';
    let mgmt = tabs[tab].tables['reimbursable-op-ex'].rows[rowIdentifier].valueCells[reimbMgmtIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue || 0;
    if (!isFinite(mgmt))
        mgmt = 0;
    
    const result = computeMgmtValue(checkbox, mgmt, cam, adminFee);
    
    return result;
}

export function recomputeInsurance({tab, tabs, precomputedValues, index, newCheckbox = null}) {
    const cells = tabs[tab].tables['reimbursement-types'].rows[index].valueCells;
    const checkbox = newCheckbox === null ? cells[insuranceCheckboxCellIndex].value : newCheckbox;
    const rowIdentifier = 'insurance';
    let insurance = tabs[tab].tables['reimbursable-op-ex'].rows[rowIdentifier].valueCells[reimbInsuranceIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue || 0;
    if (!isFinite(insurance))
        insurance = 0;
    return computeInsuranceValue(checkbox, insurance);
}

export function recomputeTaxes({tab, tabs, precomputedValues, index, newCheckbox = null}) {
    const cells = tabs[tab].tables['reimbursement-types'].rows[index].valueCells;
    const checkbox = newCheckbox === null ? cells[taxesCheckboxCellIndex].value : newCheckbox;
    const rowIdentifier = 'real-estate-taxes';
    let taxes = tabs[tab].tables['reimbursable-op-ex'].rows[rowIdentifier].valueCells[reimbTaxesIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue || 0;
    if (!isFinite(taxes))
        taxes = 0;
    return computeTaxesValue(checkbox, taxes);
}

export function computeReimbTypes({result, tab, precomputedValues, newSqft = null, newCam = null, newMgmt = null, newInsurance = null, newTaxes = null, reimbTypesManuallyModified, forceRecalculation = false}) {
    if (reimbTypesManuallyModified && !forceRecalculation) {
        return {
            data: {
                tabs: cloneDeep(result),
            }
        };
    }

    const tabs = cloneDeep(result);
    const state = {};
    
    if (newCam !== null || newSqft !== null) {
        for (let index = 0; index < reimbursementTypesNo; index++) {
            tabs[tab].tables['reimbursement-types'].rows[index].valueCells[camCellIndex].value = recomputeCam({
                tab,
                tabs,
                precomputedValues,
                index,
            });
        }
    }
    
    if (newMgmt !== null || newSqft !== null) {
        for (let index = 0; index < reimbursementTypesNo; index++) {
            tabs[tab].tables['reimbursement-types'].rows[index].valueCells[mgmtCellIndex].value = recomputeMgmt({
                tab,
                tabs,
                precomputedValues,
                index,
            });
        }
    }
    
    if (newInsurance !== null || newSqft !== null) {
        for (let index = 0; index < reimbursementTypesNo; index++) {
            tabs[tab].tables['reimbursement-types'].rows[index].valueCells[insuranceCellIndex].value = recomputeInsurance({
                tab,
                tabs,
                precomputedValues,
                index,
            });
        }
    }
    
    if (newTaxes !== null || newSqft !== null) {
        for (let index = 0; index < reimbursementTypesNo; index++) {
            tabs[tab].tables['reimbursement-types'].rows[index].valueCells[taxesCellIndex].value = recomputeTaxes({
                tab,
                tabs,
                precomputedValues,
                index,
            });
        }
    }

    state.data = {tabs};
    
    return state;
}